import { supportServiceConnectClient } from "api";

import {
  GetEscalationGroupsRequest,
  GetEscalationGroupsResponse,
  GetOrgSettingsRequest,
  GetOrgSettingsResponse,
  UpdateOrgSettingsRequest,
  UpdateOrgSettingsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/loneworker/admin/v1/admin_service_pb";
import { MonitoringCompany } from "@safetyculture/s12-apis-connect-web/s12/loneworker/v1/monitoring_pb";

import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";

export const getLoneworkerOrgSettings = async (
  orgId: string,
  headers: Record<RequestMetadata, string>
): Promise<GetOrgSettingsResponse> => {
  const req = new GetOrgSettingsRequest({ orgId: toUUID(orgId) });
  return supportServiceConnectClient.getLoneworkerOrgSettings(req, { headers });
};

export const updateLoneworkerOrgSettings = async (
  orgId: string,
  monitoringSeatsTotal: number,
  monitoringCompany: MonitoringCompany,
  headers: Record<RequestMetadata, string>
): Promise<UpdateOrgSettingsResponse> => {
  const req = new UpdateOrgSettingsRequest({
    orgId: toUUID(orgId),
    monitoringSeatsTotal,
    monitoringCompany,
  });
  return supportServiceConnectClient.updateLoneworkerOrgSettings(req, {
    headers,
  });
};

export const getLoneworkerEscalationGroups = async (
  orgId: string,
  headers: Record<RequestMetadata, string>
): Promise<GetEscalationGroupsResponse> => {
  const req = new GetEscalationGroupsRequest({ orgId: toUUID(orgId) });
  return supportServiceConnectClient.getLoneworkerEscalationGroups(req, {
    headers,
  });
};
